<template>
    <div>
		<hr>
		<div v-if="!isEmptyObject(meta)">
			<div class="form-group">
				<label for="title" class="font-weight-bold">Widget Label</label>
				<input type="text" class="form-control" v-model="meta.title" id="title" placeholder="Label yang akan ditampilkan di homepage">
			</div>
			<hr>
		</div>
		<div class="form-group">
			<label for="url">Title</label>
			<input type="text" class="form-control" v-model="config.title" id="url" placeholder="Input title for banner" required>
		</div>
		<div class="form-group">
			<label for="url">Link To</label>
			<input type="text" class="form-control" v-model="config.url" id="url" placeholder="Input url for banner" required>
		</div>
		<!-- start upload image area -->
		<div class="form-group">
			<label for="image">Image</label>
			<button class="btn btn-sm btn-plain text-danger" v-if="config.image_url !== undefined && config.image_url !== ''" @click="removeImage('desktop')">
				<i class="bi-x-circle"></i> Remove Image
			</button>
			<div class="my-2 text-center preview-image" v-if="config.image_url !== undefined && config.image_url !== ''">
				<img class="img-fluid rounded" :src="config.image_url" alt="Uploaded Image">
			</div>
			<div
				v-if="isUploading && config.image_url === ''"
				class="pc-image-empty"
			>
				<div class="image-loading">
					<div class="is-loading"></div>
				</div>
			</div>
			<div
				v-else-if="config.image_url === ''"
				class="pc-image-empty cursor-pointer"
				@click="uploadImage('desktop')"
			>
				<div class="image-upload-placeholder">
					<i class="fi fi-rr-picture image-placeholder"></i>
					<div class="text-placeholder">
						Klik untuk upload.
					</div>
				</div>
			</div>
			<div class="pc-input-desc">
				Upload image dengan resolusi 1300x183px agar fit dengan ukuran banner.
			</div>
		</div>
		<div class="form-group">
			<label for="image">Mobile Image</label>
			<button class="btn btn-sm btn-plain text-danger" v-if="config.mobile_image_url !== undefined && config.mobile_image_url !== ''" @click="removeImage('mobile')">
				<i class="bi-x-circle"></i> Remove Mobile Image
			</button>
			<div class="my-2 text-center preview-image" v-if="config.mobile_image_url !== undefined && config.mobile_image_url !== ''">
				<img class="img-fluid rounded" :src="config.mobile_image_url" alt="Uploaded Image">
			</div>
			<div
				v-if="isMobileUploading && config.mobile_image_url === ''"
				class="pc-image-empty"
			>
				<div class="image-loading">
					<div class="is-loading"></div>
				</div>
			</div>
			<div
				v-else-if="config.mobile_image_url == undefined || config.mobile_image_url === ''"
				class="pc-image-empty cursor-pointer"
				@click="uploadImage('mobile')"
			>
				<div class="image-upload-placeholder">
					<i class="fi fi-rr-picture image-placeholder"></i>
					<div class="text-placeholder">
						Klik untuk upload.
					</div>
				</div>
			</div>
			<div class="pc-input-desc">
				Upload image dengan resolusi 640x640px agar fit dengan ukuran banner.
			</div>
		</div>
		<div class="form-group buttons m-0 hidden">
			<input
				type="file"
				accept="image/*"
				class="input-file"
				ref="imageUploader"
				id="pc-product-images-file"
				@change="onInputImageChange"
				multiple
			/>
			<label
				for="pc-product-images-file"
				class="btn btn-primary"
				:class="{ 'is-loading': isUploading }"
				>Upload images</label
			>
			<div class="pc-input-desc">
				Make sure your image resolution is 1296x324 px
			</div>
		</div>
		<!-- end upload image area -->
	</div>
</template>
<script>
import mediaApi from '@/api/media';
import { isEmptyObject } from '@/lib/helper';

export default {
	name: 'SellingPoint',
	props: {
		config: {
			type: Object,
			default: () => ({
				title: 'Single Banner',
				url: null,
				image_url: 'https://cdn.ostock.id/img/banner/inventro-banner-1.png',
				mobile_image_url: 'https://cdn.ostock.id/img/banner/inventro-banner-1.png',
			}),
		},
		meta: {},
	},
	data() {
		return {
			isUploading: false,
			isMobileUploading: false,
			stateUpload: 'desktop',
		};
	},
	methods: {
		isEmptyObject,
		removeImage(state) {
			if (state === 'desktop') {
				this.$set(this.config, 'image_url', '');
			} else {
				this.$set(this.config, 'mobile_image_url', '');
			}
			console.log(this.config.image_url);
			console.log(this.config.mobile_image_url);
		},
		uploadImage(state) {
			console.log('up');
			this.stateUpload = state;
			const inputFile = this.$refs.imageUploader;
			console.log(inputFile);
			inputFile.click();
		},
		onInputImageChange(event) {
			if (this.stateUpload === 'desktop') {
				this.isUploading = true;
				this.$set(this.config, 'image_url', '');
			} else {
				this.isMobileUploading = true;
				this.$set(this.config, 'mobile_image_url', '');
			}
			const maxUploadSize = 3; // MB
			const input = event.target;
			for (let i = 0; i < input.files.length; i++) {
				const image = input.files[i];

				// Check File Size
				let fileSize = image.size;
				fileSize /= 1048576;

				const isFileSizeTooLarge = fileSize > maxUploadSize;

				// Show Notice if size too large
				if (isFileSizeTooLarge) {
					const noticeMessage = `'${image.name}' size is too large (max 3MB)`;
					this.$notify({
						group: 'admin-sliders',
						text: noticeMessage,
						type: 'warn',
					});
					break;
				}

				// Start Upload
				const uploadParams = new FormData();
				uploadParams.append('image', image);

				const callback = (response) => {
					const path = response.data;
					const url = `${this.mediaUrlPrefix}/${path}`;

					if (this.stateUpload === 'desktop') {
						this.isUploading = false;
						this.$set(this.config, 'image_url', url);
					} else {
						this.isMobileUploading = false;
						this.$set(this.config, 'mobile_image_url', url);
					}
				};

				const errorCallback = (e) => {
					this.isUploading = false;
					this.isMobileUploading = false;
					console.log(e);
				};

				// Upload Image
				mediaApi.uploadImage(uploadParams, callback, errorCallback);
			}
			event.target.files = null;
			event.target.value = '';
		},
	},
};
</script>
<style lang="scss" scoped>
	label {
		font-weight: 700;
		font-size: 16px;
		line-height: 150%;
	}

	.form-control {
		border: 2px solid #1F1F1F61;
		height: calc(2.3em + 0.75rem + 2px);
	}

	.single-banner {
		img {
			border-radius: 16px;
		}
	}
</style>
